module.exports = __webpack_public_path__ + "static/media/Sleep_and_rest_patterns.77762b0f.png";